module.exports = __webpack_public_path__ + "img/step-3-mobile.4fdbcc64.gif";